var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRss = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 42,
  height: 42,
  viewBox: "0 0 42 42",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21 1.5C10.2304 1.5 1.5 10.2304 1.5 21C1.5 31.7696 10.2304 40.5 21 40.5C31.7696 40.5 40.5 31.7696 40.5 21C40.5 10.2304 31.7696 1.5 21 1.5ZM0.5 21C0.5 9.67816 9.67816 0.5 21 0.5C32.3218 0.5 41.5 9.67816 41.5 21C41.5 32.3218 32.3218 41.5 21 41.5C9.67816 41.5 0.5 32.3218 0.5 21Z",
  fill: "white"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29 27H26.3335C26.3335 20.7505 21.2496 15.6665 15.0002 15.6665V13C22.7196 13 29 19.2805 29 27ZM15.0002 25C15.0002 23.8955 15.8956 23 17.0001 23C18.1046 23 19.0001 23.8955 19.0001 25C19.0001 26.1045 18.1046 27 17.0001 27C15.8956 27 15.0002 26.1045 15.0002 25ZM21.6669 27H24.3334C24.3334 21.8535 20.1464 17.6665 15 17.6665V20.3335C18.676 20.3335 21.6669 23.324 21.6669 27Z",
  fill: "white"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRss);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/rss.f43a0eb29fcf46257a9cdc95bd7e8201.svg";